import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><div parentName="p" {...{
        "className": "mermaid"
      }}><svg parentName="div" {...{
          "aria-role-description": ["flowchart-v2"],
          "role": "graphics-document document",
          "viewBox": "-7.5 -8 792.25 174.5",
          "style": {
            "maxWidth": "792.25px"
          },
          "xmlns": "http://www.w3.org/2000/svg",
          "width": "100%",
          "id": "mermaid-0"
        }}><style parentName="svg">{`#mermaid-0{font-family:arial,sans-serif;font-size:16px;fill:#333;}#mermaid-0 .error-icon{fill:#552222;}#mermaid-0 .error-text{fill:#552222;stroke:#552222;}#mermaid-0 .edge-thickness-normal{stroke-width:2px;}#mermaid-0 .edge-thickness-thick{stroke-width:3.5px;}#mermaid-0 .edge-pattern-solid{stroke-dasharray:0;}#mermaid-0 .edge-pattern-dashed{stroke-dasharray:3;}#mermaid-0 .edge-pattern-dotted{stroke-dasharray:2;}#mermaid-0 .marker{fill:#333333;stroke:#333333;}#mermaid-0 .marker.cross{stroke:#333333;}#mermaid-0 svg{font-family:arial,sans-serif;font-size:16px;}#mermaid-0 .label{font-family:arial,sans-serif;color:#333;}#mermaid-0 .cluster-label text{fill:#333;}#mermaid-0 .cluster-label span,#mermaid-0 p{color:#333;}#mermaid-0 .label text,#mermaid-0 span,#mermaid-0 p{fill:#333;color:#333;}#mermaid-0 .node rect,#mermaid-0 .node circle,#mermaid-0 .node ellipse,#mermaid-0 .node polygon,#mermaid-0 .node path{fill:#ECECFF;stroke:#9370DB;stroke-width:1px;}#mermaid-0 .flowchart-label text{text-anchor:middle;}#mermaid-0 .node .label{text-align:center;}#mermaid-0 .node.clickable{cursor:pointer;}#mermaid-0 .arrowheadPath{fill:#333333;}#mermaid-0 .edgePath .path{stroke:#333333;stroke-width:2.0px;}#mermaid-0 .flowchart-link{stroke:#333333;fill:none;}#mermaid-0 .edgeLabel{background-color:#e8e8e8;text-align:center;}#mermaid-0 .edgeLabel rect{opacity:0.5;background-color:#e8e8e8;fill:#e8e8e8;}#mermaid-0 .labelBkg{background-color:rgba(232, 232, 232, 0.5);}#mermaid-0 .cluster rect{fill:#ffffde;stroke:#aaaa33;stroke-width:1px;}#mermaid-0 .cluster text{fill:#333;}#mermaid-0 .cluster span,#mermaid-0 p{color:#333;}#mermaid-0 div.mermaidTooltip{position:absolute;text-align:center;max-width:200px;padding:2px;font-family:arial,sans-serif;font-size:12px;background:hsl(80, 100%, 96.2745098039%);border:1px solid #aaaa33;border-radius:2px;pointer-events:none;z-index:100;}#mermaid-0 .flowchartTitleText{text-anchor:middle;font-size:18px;fill:#333;}#mermaid-0 :root{--mermaid-font-family:arial,sans-serif;}`}</style><g parentName="svg"><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "12",
              "markerWidth": "12",
              "markerUnits": "userSpaceOnUse",
              "refY": "5",
              "refX": "6",
              "viewBox": "0 0 10 10",
              "className": "marker flowchart",
              "id": "mermaid-0_flowchart-pointEnd"
            }}><path parentName="marker" {...{
                "style": {
                  "strokeWidth": "1",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "d": "M 0 0 L 10 5 L 0 10 z"
              }}></path></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "12",
              "markerWidth": "12",
              "markerUnits": "userSpaceOnUse",
              "refY": "5",
              "refX": "4.5",
              "viewBox": "0 0 10 10",
              "className": "marker flowchart",
              "id": "mermaid-0_flowchart-pointStart"
            }}><path parentName="marker" {...{
                "style": {
                  "strokeWidth": "1",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "d": "M 0 5 L 10 10 L 10 0 z"
              }}></path></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "11",
              "markerWidth": "11",
              "markerUnits": "userSpaceOnUse",
              "refY": "5",
              "refX": "11",
              "viewBox": "0 0 10 10",
              "className": "marker flowchart",
              "id": "mermaid-0_flowchart-circleEnd"
            }}><circle parentName="marker" {...{
                "style": {
                  "strokeWidth": "1",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "r": "5",
                "cy": "5",
                "cx": "5"
              }}></circle></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "11",
              "markerWidth": "11",
              "markerUnits": "userSpaceOnUse",
              "refY": "5",
              "refX": "-1",
              "viewBox": "0 0 10 10",
              "className": "marker flowchart",
              "id": "mermaid-0_flowchart-circleStart"
            }}><circle parentName="marker" {...{
                "style": {
                  "strokeWidth": "1",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "r": "5",
                "cy": "5",
                "cx": "5"
              }}></circle></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "11",
              "markerWidth": "11",
              "markerUnits": "userSpaceOnUse",
              "refY": "5.2",
              "refX": "12",
              "viewBox": "0 0 11 11",
              "className": "marker cross flowchart",
              "id": "mermaid-0_flowchart-crossEnd"
            }}><path parentName="marker" {...{
                "style": {
                  "strokeWidth": "2",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "d": "M 1,1 l 9,9 M 10,1 l -9,9"
              }}></path></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "11",
              "markerWidth": "11",
              "markerUnits": "userSpaceOnUse",
              "refY": "5.2",
              "refX": "-1",
              "viewBox": "0 0 11 11",
              "className": "marker cross flowchart",
              "id": "mermaid-0_flowchart-crossStart"
            }}><path parentName="marker" {...{
                "style": {
                  "strokeWidth": "2",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "d": "M 1,1 l 9,9 M 10,1 l -9,9"
              }}></path></marker><g parentName="g" {...{
              "className": "root"
            }}><g parentName="g" {...{
                "className": "clusters"
              }}></g><g parentName="g" {...{
                "className": "edgePaths"
              }}></g><g parentName="g" {...{
                "className": "edgeLabels"
              }}></g><g parentName="g" {...{
                "className": "nodes"
              }}><g parentName="g" {...{
                  "transform": "translate(-7.5, -8)",
                  "className": "root"
                }}><g parentName="g" {...{
                    "className": "clusters"
                  }}><g parentName="g" {...{
                      "id": "Open4Feedback",
                      "className": "cluster default flowchart-label"
                    }}><rect parentName="g" {...{
                        "height": "158.5",
                        "width": "776.25",
                        "y": "8",
                        "x": "8",
                        "ry": "0",
                        "rx": "0",
                        "style": {}
                      }}></rect><g parentName="g" {...{
                        "transform": "translate(333.1640625, 8)",
                        "className": "cluster-label"
                      }}><foreignObject parentName="g" {...{
                          "height": "19",
                          "width": "125.921875"
                        }}><div parentName="foreignObject" {...{
                            "style": {
                              "display": "inline-block",
                              "whiteSpace": "nowrap"
                            },
                            "xmlns": "http://www.w3.org/1999/xhtml"
                          }}><span parentName="div" {...{
                              "className": "nodeLabel"
                            }}>{`Proposal review`}</span></div></foreignObject></g></g></g><g parentName="g" {...{
                    "className": "edgePaths"
                  }}><path parentName="g" {...{
                      "markerEnd": "url(#mermaid-0_flowchart-pointEnd)",
                      "style": {
                        "fill": "none"
                      },
                      "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-Feedback LE-Feedback1",
                      "id": "L-Feedback-Feedback1-0",
                      "d": "M121.5,87.25L125.667,87.25C129.833,87.25,138.167,87.25,145.617,87.25C153.067,87.25,159.633,87.25,162.917,87.25L166.2,87.25"
                    }}></path><path parentName="g" {...{
                      "markerEnd": "url(#mermaid-0_flowchart-pointEnd)",
                      "style": {
                        "fill": "none"
                      },
                      "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-Feedback1 LE-Feedback2",
                      "id": "L-Feedback1-Feedback2-0",
                      "d": "M327.734,87.25L331.901,87.25C336.068,87.25,344.401,87.25,351.851,87.25C359.301,87.25,365.868,87.25,369.151,87.25L372.434,87.25"
                    }}></path><path parentName="g" {...{
                      "markerEnd": "url(#mermaid-0_flowchart-pointEnd)",
                      "style": {
                        "fill": "none"
                      },
                      "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-Feedback2 LE-Approvals",
                      "id": "L-Feedback2-Approvals-0",
                      "d": "M535.047,87.25L539.214,87.25C543.38,87.25,551.714,87.25,559.164,87.25C566.614,87.25,573.18,87.25,576.464,87.25L579.747,87.25"
                    }}></path></g><g parentName="g" {...{
                    "className": "edgeLabels"
                  }}><g parentName="g" {...{
                      "className": "edgeLabel"
                    }}><g parentName="g" {...{
                        "transform": "translate(0, 0)",
                        "className": "label"
                      }}><foreignObject parentName="g" {...{
                          "height": "0",
                          "width": "0"
                        }}><div parentName="foreignObject" {...{
                            "style": {
                              "display": "inline-block",
                              "whiteSpace": "nowrap"
                            },
                            "xmlns": "http://www.w3.org/1999/xhtml"
                          }}><span parentName="div" {...{
                              "className": "edgeLabel"
                            }}></span></div></foreignObject></g></g><g parentName="g" {...{
                      "className": "edgeLabel"
                    }}><g parentName="g" {...{
                        "transform": "translate(0, 0)",
                        "className": "label"
                      }}><foreignObject parentName="g" {...{
                          "height": "0",
                          "width": "0"
                        }}><div parentName="foreignObject" {...{
                            "style": {
                              "display": "inline-block",
                              "whiteSpace": "nowrap"
                            },
                            "xmlns": "http://www.w3.org/1999/xhtml"
                          }}><span parentName="div" {...{
                              "className": "edgeLabel"
                            }}></span></div></foreignObject></g></g><g parentName="g" {...{
                      "className": "edgeLabel"
                    }}><g parentName="g" {...{
                        "transform": "translate(0, 0)",
                        "className": "label"
                      }}><foreignObject parentName="g" {...{
                          "height": "0",
                          "width": "0"
                        }}><div parentName="foreignObject" {...{
                            "style": {
                              "display": "inline-block",
                              "whiteSpace": "nowrap"
                            },
                            "xmlns": "http://www.w3.org/1999/xhtml"
                          }}><span parentName="div" {...{
                              "className": "edgeLabel"
                            }}></span></div></foreignObject></g></g></g><g parentName="g" {...{
                    "className": "nodes"
                  }}><g parentName="g" {...{
                      "transform": "translate(77.25, 87.25)",
                      "id": "flowchart-Feedback-0",
                      "className": "node default secondary CircleSize50 flowchart-label"
                    }}><circle parentName="g" {...{
                        "height": "72",
                        "width": "88.5",
                        "r": "44.25",
                        "ry": "0",
                        "rx": "0",
                        "style": {}
                      }}></circle><g parentName="g" {...{
                        "transform": "translate(-36.75, -28.5)",
                        "style": {},
                        "className": "label"
                      }}><rect parentName="g"></rect><foreignObject parentName="g" {...{
                          "height": "57",
                          "width": "73.5"
                        }}><div parentName="foreignObject" {...{
                            "style": {
                              "display": "inline-block",
                              "whiteSpace": "nowrap"
                            },
                            "xmlns": "http://www.w3.org/1999/xhtml"
                          }}><span parentName="div" {...{
                              "className": "nodeLabel"
                            }}>{`Open for `}<br parentName="span"></br>{`feedback `}<br parentName="span"></br>{` status`}</span></div></foreignObject></g></g><g parentName="g" {...{
                      "transform": "translate(249.6171875, 87.25)",
                      "id": "flowchart-Feedback1-1",
                      "className": "node default default flowchart-label"
                    }}><rect parentName="g" {...{
                        "height": "34",
                        "width": "156.234375",
                        "y": "-17",
                        "x": "-78.1171875",
                        "ry": "0",
                        "rx": "0",
                        "style": {},
                        "className": "basic label-container"
                      }}></rect><g parentName="g" {...{
                        "transform": "translate(-70.6171875, -9.5)",
                        "style": {},
                        "className": "label"
                      }}><rect parentName="g"></rect><foreignObject parentName="g" {...{
                          "height": "19",
                          "width": "141.234375"
                        }}><div parentName="foreignObject" {...{
                            "style": {
                              "display": "inline-block",
                              "whiteSpace": "nowrap"
                            },
                            "xmlns": "http://www.w3.org/1999/xhtml"
                          }}><span parentName="div" {...{
                              "className": "nodeLabel"
                            }}>{`Receive feedback`}</span></div></foreignObject></g></g><g parentName="g" {...{
                      "transform": "translate(456.390625, 87.25)",
                      "id": "flowchart-Feedback2-2",
                      "className": "node default default flowchart-label"
                    }}><rect parentName="g" {...{
                        "height": "34",
                        "width": "157.3125",
                        "y": "-17",
                        "x": "-78.65625",
                        "ry": "0",
                        "rx": "0",
                        "style": {},
                        "className": "basic label-container"
                      }}></rect><g parentName="g" {...{
                        "transform": "translate(-71.15625, -9.5)",
                        "style": {},
                        "className": "label"
                      }}><rect parentName="g"></rect><foreignObject parentName="g" {...{
                          "height": "19",
                          "width": "142.3125"
                        }}><div parentName="foreignObject" {...{
                            "style": {
                              "display": "inline-block",
                              "whiteSpace": "nowrap"
                            },
                            "xmlns": "http://www.w3.org/1999/xhtml"
                          }}><span parentName="div" {...{
                              "className": "nodeLabel"
                            }}>{`Address feedback`}</span></div></foreignObject></g></g><g parentName="g" {...{
                      "transform": "translate(672.1484375, 87.25)",
                      "id": "flowchart-Approvals-3",
                      "className": "node default default flowchart-label"
                    }}><rect parentName="g" {...{
                        "height": "53",
                        "width": "174.203125",
                        "y": "-26.5",
                        "x": "-87.1015625",
                        "ry": "0",
                        "rx": "0",
                        "style": {},
                        "className": "basic label-container"
                      }}></rect><g parentName="g" {...{
                        "transform": "translate(-79.6015625, -19)",
                        "style": {},
                        "className": "label"
                      }}><rect parentName="g"></rect><foreignObject parentName="g" {...{
                          "height": "38",
                          "width": "159.203125"
                        }}><div parentName="foreignObject" {...{
                            "style": {
                              "display": "inline-block",
                              "whiteSpace": "nowrap"
                            },
                            "xmlns": "http://www.w3.org/1999/xhtml"
                          }}><span parentName="div" {...{
                              "className": "nodeLabel"
                            }}>{`Receive`}<br parentName="span"></br>{`minimum approvals`}</span></div></foreignObject></g></g></g></g></g></g></g></svg></div></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      